module.exports = __webpack_public_path__ + "img/svg/icon-matches.f9dc6ef51ad29f03aa5db8a89ed4ff0d.svg";